/* eslint-disable no-unused-vars */
import { useCallback, Fragment, useContext } from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { Item } from './Item';
import styled from 'styled-components';
import { Palette } from 'config';

export const SelectedItems = ({ changeColumnsApi, fieldNameToHeaderName, draggableFlag }) => {
  const onDragEnd = useCallback((result, stateData) => {
    if (!result.destination) {
      return;
    }
    if (result.destination.index !== result.source.index) {
      draggableFlag.current = true;
      const reorderedItems = Array.from(stateData.state);
      const [removed] = reorderedItems.splice(result.source.index, 1);
      reorderedItems.splice(result.destination.index, 0, removed);
      stateData.setState(new Set(reorderedItems));
    } else {
      return;
    }
  }, []);

  return (
    <Container>
      {Object.entries(changeColumnsApi).map(([sectionName, stateData]) => {
        return (
          <Fragment key={sectionName}>
            <DragDropContext onDragEnd={(result) => onDragEnd(result, stateData)}>
              <Droppable droppableId='droppableData'>
                {(provided, snapshot) => (
                  <DragDropContainer {...provided.droppableProps} ref={provided.innerRef}>
                    <Text>{sectionName}:</Text>
                    {changeColumnsApi[sectionName].state.map((item, index) => (
                      <Draggable
                        key={`${item}_${index}`}
                        draggableId={`${item}_${index}`}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <Item
                            provided={provided}
                            fieldNameToHeaderName={fieldNameToHeaderName}
                            item={item}
                            sectionName={sectionName}
                          />
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </DragDropContainer>
                )}
              </Droppable>
            </DragDropContext>
          </Fragment>
        );
      })}
    </Container>
  );
};

const Container = styled('div')`
  width: calc(601px - 253px);
  height: calc(48px + 389px);
  text-align: center;
  border: 1px solid ${Palette.PrimaryGray._200};
  border-left: none;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  background: ${Palette.PrimaryGray._100};
`;

const DragDropContainer = styled('div')`
  border: 1px solid red;
  background: ${Palette.PrimaryGray._200};
  padding: 8px;
  border-radius: 8px;
  border: 1px solid ${Palette.PrimaryGray._200};
  cursor: grab;
`;

const Text = styled.p`
  color: ${Palette.PrimaryGray._500};
  text-align: left;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;
